import { render, staticRenderFns } from "./add_acco.vue?vue&type=template&id=668edf70&scoped=true"
import script from "./add_acco.vue?vue&type=script&lang=js"
export * from "./add_acco.vue?vue&type=script&lang=js"
import style0 from "./add_acco.vue?vue&type=style&index=0&id=668edf70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668edf70",
  null
  
)

export default component.exports